/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAdditionServiceListByCreateOrderRespVo } from './GetAdditionServiceListByCreateOrderRespVo';
import {
    GetAdditionServiceListByCreateOrderRespVoFromJSON,
    GetAdditionServiceListByCreateOrderRespVoFromJSONTyped,
    GetAdditionServiceListByCreateOrderRespVoToJSON,
    GetAdditionServiceListByCreateOrderRespVoToJSONTyped,
} from './GetAdditionServiceListByCreateOrderRespVo';

/**
 * 
 * @export
 * @interface GetAdditionGroupListByCreateOrderRespVo
 */
export interface GetAdditionGroupListByCreateOrderRespVo {
    /**
     * 附加服务分组编号
     * @type {number}
     * @memberof GetAdditionGroupListByCreateOrderRespVo
     */
    groupId?: number;
    /**
     * 分组名称
     * @type {string}
     * @memberof GetAdditionGroupListByCreateOrderRespVo
     */
    groupName?: string;
    /**
     * 分组中文名称
     * @type {string}
     * @memberof GetAdditionGroupListByCreateOrderRespVo
     */
    groupNameCn?: string;
    /**
     * 分组韩文名称
     * @type {string}
     * @memberof GetAdditionGroupListByCreateOrderRespVo
     */
    groupNameKr?: string;
    /**
     * 附加服务列表
     * @type {Array<GetAdditionServiceListByCreateOrderRespVo>}
     * @memberof GetAdditionGroupListByCreateOrderRespVo
     */
    services?: Array<GetAdditionServiceListByCreateOrderRespVo>;
}

/**
 * Check if a given object implements the GetAdditionGroupListByCreateOrderRespVo interface.
 */
export function instanceOfGetAdditionGroupListByCreateOrderRespVo(value: object): value is GetAdditionGroupListByCreateOrderRespVo {
    return true;
}

export function GetAdditionGroupListByCreateOrderRespVoFromJSON(json: any): GetAdditionGroupListByCreateOrderRespVo {
    return GetAdditionGroupListByCreateOrderRespVoFromJSONTyped(json, false);
}

export function GetAdditionGroupListByCreateOrderRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdditionGroupListByCreateOrderRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupNameCn': json['groupNameCn'] == null ? undefined : json['groupNameCn'],
        'groupNameKr': json['groupNameKr'] == null ? undefined : json['groupNameKr'],
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(GetAdditionServiceListByCreateOrderRespVoFromJSON)),
    };
}

export function GetAdditionGroupListByCreateOrderRespVoToJSON(json: any): GetAdditionGroupListByCreateOrderRespVo {
    return GetAdditionGroupListByCreateOrderRespVoToJSONTyped(json, false);
}

export function GetAdditionGroupListByCreateOrderRespVoToJSONTyped(value?: GetAdditionGroupListByCreateOrderRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupId': value['groupId'],
        'groupName': value['groupName'],
        'groupNameCn': value['groupNameCn'],
        'groupNameKr': value['groupNameKr'],
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(GetAdditionServiceListByCreateOrderRespVoToJSON)),
    };
}

